export const sampleDeploysWithErrors = {
  count: 7,
  deploys: [
    {
      id: 1,
      createdAt: new Date(),
      environment: "production",
      groupCreatedCount: 10,
      revision: "da39a3e",
      projectName: "Backend (sample)",
    },
    {
      id: 2,
      createdAt: new Date(),
      environment: "qa",
      groupCreatedCount: 8,
      revision: "86f7e43",
      projectName: "Frontend (sample)",
    },
    {
      id: 3,
      createdAt: new Date(),
      environment: "staging",
      groupCreatedCount: 3,
      revision: "e9d71f5",
      projectName: "Backend (sample)",
    },
    {
      id: 4,
      createdAt: new Date(),
      environment: "staging",
      groupCreatedCount: 1,
      revision: "84a5168",
      projectName: "Backend (sample)",
    },
    {
      id: 5,
      createdAt: new Date(),
      environment: "production",
      groupCreatedCount: 5,
      revision: "3c36383",
      projectName: "Frontend (sample)",
    },
  ],
};
